import { getPromotionInfo } from '@/hooks/useBdVid'

// 点击弹窗中的立即购买按钮, 开始结账流程。例如，点击“结账”按钮。
export const fbInitiateCheckoutEvent = () => {
  const { promotion_type, promotion_id } = getPromotionInfo()
  ;(window as any)?.fbq?.('track', 'InitiateCheckout', {
    promotion_type,
    promotion_id
  })
}

// 用户完成注册。
export const fbCompleteRegistrationEvent = () => {
  const { promotion_type, promotion_id } = getPromotionInfo()
  ;(window as any)?.fbq?.('track', 'CompleteRegistration', {
    promotion_type,
    promotion_id
  })
}
